<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="./../assets/imgs/137/base.png" alt="" />
      <div class="technological-process">
        <div class="rhtj mar-t2">
          <img class="top" src="./../assets/imgs/125/desc-title.png" alt="" />
          <div class="content">
            成华区为推进平台聚才育才，按照《成都市成华区关于“建设全国创新人才高地特色区加快人才集聚发展的若干政策”认定类项目申报实施办法》，对新设立或新获评的人才培育平台提供资金资助。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/137/title1.png" alt="" />
          <div class="content" style="background-color: #fff">
            支持新设立的院士（专家）创新工作站、博士后科研流动站（工作站）、博士后创新实践基地、博士后平台储备单位的区内企业、科研院所等用人主体单位。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/137/title2.png" alt="" />
          <div class="content">
            <div class="des">
              <div>
                （一）对新设立的院士（专家）创新工作站的区内用人主体单位给予50万元建站资助。
              </div>
            </div>
            <div class="des">
              <div>
                （二）由成华区推荐并获批的博士后科研流动站、工作站和创新实践基地，在招收1名及以上博士后人员进站从事科研工作后，一次性给予单位20万元资助；新获批博士后平台储备单位的，一次性给予单位5万元资助。
              </div>
            </div>
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/137/title3.png" alt="" />
          <div
            class="content"
            style="background-color: #fff; font-weight: bolder"
          >
            以当年申报通知为准。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/137/title4.png" alt="" />
          <div
            class="content"
            style="background-color: #fff; font-weight: bolder"
          >
            按照每年度通知时间确定。
          </div>
        </div>
        <div class="contact" style="margin-top: 0.3rem">
          <img class="top" src="./../assets/imgs/137/title5.png" alt="" />
          <div class="content">
            <div style="display: flex; align-items: center">
              <div class="circle"></div>
              院士（专家）创新工作站
            </div>
            <div class="number" style="margin-top: 0.18rem">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-84080490">028-84080490</a>
              </div>
            </div>
            <div class="unit" style="border-bottom: 0.01rem dashed #0839B7;padding-bottom: 0.2rem;">
              <span class="label">责任单位：</span>
              成都市成华区科协
            </div>
          </div>
          <div class="content" style="border-bottom: 1px solid #0839B7;">
            <div style="display: flex; align-items: center">
              <div class="circle"></div>
              博士后“两站一基地”
            </div>
            <div class="number" style="margin-top: 0.18rem">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-84310100">028-84310100</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              成都市成华区人社局
            </div>
          </div>
        </div>
        <!-- <div class="codes">
                  <img class="info" src="../assets/imgs/133/code.png" />
              </div> -->
      </div>
    </section>
    <!-- <call phone="028-84080490"></call> -->
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.circle {
  width: 0.2rem;
  height: 0.2rem;
  border-radius: 50%;
  border: 0.06rem solid #ff6d60;
  margin-right: 0.08rem;
}
.xlrclh {
  background-color: $base-back;
  padding-top: 0.3rem;

  .top-img {
    width: 7.26rem;
    height: 5.6rem;
  }

  .technological-process {
    transform: translateY(-1.9rem);

    .rhtj {
      position: relative;

      .top {
        width: 6.86rem;
        height: 2.12rem;
      }

      .content {
        width: 6.85rem;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        background: #ffffff;
        font-size: 0.26rem;
        color: #4e4e4e;
        text-align: left;
        position: relative;
        font-weight: 500;
        line-height: 0.44rem;
      }
    }

    .zccl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          position: relative;
          text-align: left;
          margin-top: 0.2rem;
          .title {
            position: absolute;
            top: -0.5rem;
            left: 50%;
            transform: translateX(-50%);
            width: 4.86rem;
            height: 0.67rem;
            line-height: 0.67rem;
            display: flex;
            justify-content: center;
            align-content: center;
            font-size: 0.32rem;
            font-weight: bold;
            color: #ffffff;
            border-radius: 1rem;
            background-color: #739bfe;
          }
        }
      }
    }

    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.86rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;

        .circle-box {
          font-size: 0.34rem;
          color: #333;
          font-weight: bold;
          padding-top: 0.5rem;
          text-align: left;
          position: relative;
          .circle {
            width: 0.28rem;
            height: 0.28rem;
            border: 0.06rem solid #ff6d60;
            border-radius: 50%;
            flex-shrink: 0;
            box-sizing: border-box;
            position: absolute;
            left: 0;
            top: 0.62rem;
            display: inline-block;
          }
          .circle-txt {
            text-indent: 1.1em;
          }
        }

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          line-height: 0.44rem;

          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 130%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }

            .line-top {
              display: flex;
              width: 4.4rem;
              height: 0.55rem;
              background-image: url(../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.1rem;

              .line-num {
                width: 0.44rem;
                height: 0.44rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.18rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }

            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .info {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
